/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import moment from 'moment';
import Pagination from 'components/atoms/pagination';
import ResultMarketModal from 'components/atoms/result_market_modal';
import { getResults } from 'store/modules/market_store/actions';
import Loader from 'components/atoms/loader';

interface ResultsMarketProps {
  params: any;
}

const ResultsMarket = (props: ResultsMarketProps) => {
  const { params } = props;
  const dispatch = useDispatch();
  const { resultado, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [resultData, setResultData] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(1);

  const calc = (result: any) => {
    let valor_global = 0;
    result.map((value: any) => {
      valor_global += value.item_valor_total;
    });

    if (valor_global === 0) {
      result.map((value: any) => {
        valor_global += value.item_valor_unitario;
      });
    }
    return valor_global.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  };

  useEffect(() => {
    dispatch(getResults(params, currentPage));
  }, [params, currentPage]);

  const paginate = (currentPageResult = 1) => {
    if (currentPageResult) {
      setCurrentPage(currentPageResult);
    }
  };

  const getResult = (result: object) => {
    setResultData(result);
    setShowModal(true);
  };

  return (
    <div className="row mt-4">
      <div className="col-md-12">
        <div className="card overflow-auto">
          <div>
            <div className="pl-2 my-2 d-flex align-items-center">
              <i className="material-icons">assignment_turned_in</i>
              <b className="pl-1 mt-2">Resultados</b>
            </div>
          </div>
          <ul className="list-group list-group-flush table-responsive">
            {request?.get_results?.loading ? (
              <Loader />
            ) : (
              <table className="table table-hover table-resultados">
                <thead style={{ backgroundColor: '#EBECEF' }}>
                  <tr>
                    <th scope="col">Edital</th>
                    <th className="w-25" scope="col">
                      Órgão
                    </th>
                    <th scope="col">Vencedores</th>
                    <th scope="col">Itens</th>
                    <th scope="col">Abertura</th>
                    <th scope="col">Investimento</th>
                  </tr>
                </thead>
                <tbody>
                  {resultado?.resultados?.map((result) => (
                    <tr key={result?.licitacao?.id} onClick={() => getResult(result)}>
                      <td>{result?.licitacao?.edital}</td>
                      <td>{result?.licitacao?.orgao?.nome}</td>
                      <td>
                        {result?.licitacao?.resultados[0]?.fornecedor}
                        <small>
                          <b>
                            <em>
                              <br />e outros...
                            </em>
                          </b>
                        </small>
                      </td>
                      <td>{result?.licitacao?.resultados?.length}</td>
                      <td>{moment.parseZone(result?.licitacao?.data_validade).format('L')}</td>
                      <td>{calc(result.licitacao.resultados)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </ul>
          <div className="border rounded-bottom border-top-0 d-print-none">
            <button
              type="button"
              key="btn-bidding-more-info"
              className="btn btn-sm btn-link m-0 w-100 mb-3"
              onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
            >
              {BiddingInfoToggle ? 'Ver menos' : 'Ver mais'}
            </button>
            {BiddingInfoToggle && (
              <div className="row d-print-none">
                <div className="col-md-12 px-4 mb-5">
                  <Pagination
                    postsPerPage={10}
                    totalPosts={resultado?.total}
                    paginate={paginate}
                    currentPage={currentPage}
                    firstAndLastPage
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ResultMarketModal
        showModal={showModal}
        setShowModal={setShowModal}
        resultData={resultData}
      />
    </div>
  );
};

export default ResultsMarket;
